import React, {
  createContext, useContext, useState, useEffect,
} from 'react';
import { useLocation } from 'react-router-dom';

const NavigationContext = createContext();

export const useNavigation = () => {
  const context = useContext(NavigationContext);
  if (!context) {
    throw new Error('useNavigation must be used within NavigationProvider');
  }
  return context;
};

export function NavigationProvider({ children }) {
  const location = useLocation();
  const [breadcrumbs, setBreadcrumbs] = useState([]);
  const [pageTitle, setPageTitle] = useState('');

  // Generate breadcrumbs based on current route
  useEffect(() => {
    const generateBreadcrumbs = (pathname) => {
      const paths = pathname.split('/').filter(Boolean);
      const breadcrumbMap = {
        '': 'Home',
        formBuilder: 'Form Builder',
        agentFlowBuilder: 'Agent Flow Builder',
        form: 'Form Runtime',
        dashboard: 'Dashboard',
        settings: 'Settings',
        analytics: 'Analytics',
        agents: 'Agents',
        'data-sources': 'Data Sources',
        help: 'Help & Support',
        'chat-widget-demo': 'Chat Widget Demo',
      };

      const crumbs = [{ label: 'Home', path: '/dashboard' }];

      paths.forEach((path, index) => {
        const fullPath = `/${paths.slice(0, index + 1).join('/')}`;
        const label = breadcrumbMap[path] || path.charAt(0).toUpperCase() + path.slice(1);
        crumbs.push({ label, path: fullPath });
      });

      return crumbs;
    };

    const crumbs = generateBreadcrumbs(location.pathname);
    setBreadcrumbs(crumbs);
    setPageTitle(crumbs[crumbs.length - 1]?.label || 'Page');
  }, [location.pathname]);

  const contextValue = {
    breadcrumbs,
    pageTitle,
    setBreadcrumbs,
    setPageTitle,
  };

  return (
    <NavigationContext.Provider value={contextValue}>
      {children}
    </NavigationContext.Provider>
  );
}
